import { render } from "./CurrencyInputCustom.vue?vue&type=template&id=2de9645a&scoped=true&ts=true"
import script from "./CurrencyInputCustom.vue?vue&type=script&lang=ts"
export * from "./CurrencyInputCustom.vue?vue&type=script&lang=ts"

import "./CurrencyInputCustom.vue?vue&type=style&index=0&id=2de9645a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de9645a"]])

export default __exports__